define([
  "jquery",
  "underscore",
  "marionette",
  "backbone.syphon",
  "views/common/search_input_view",
], function ($, _, Marionette, Syphon, SearchInput) {
  new SearchInput();
});
